import CustInfo from './cust-info.vue';
import ProductInfo from './product-info.vue';
import ApplyDatumInfo from './apply-datum-info.vue';
import CreditReport from './credit-report.vue';
import PublicDebtInfo from './public-debt-info.vue';
import FixInfo from './fix-info.vue';
import CaseInfo from './case-info.vue';
import AnnexInfo from './annex-info.vue';
import RepaymentPlan from './repayment-plan.vue';
import EssentialInformation from './essential-information.vue';
/**
 * 组件
 */
export var components = {
    CustInfo: CustInfo,
    ProductInfo: ProductInfo,
    ApplyDatumInfo: ApplyDatumInfo,
    CreditReport: CreditReport,
    PublicDebtInfo: PublicDebtInfo,
    FixInfo: FixInfo,
    CaseInfo: CaseInfo,
    AnnexInfo: AnnexInfo,
    RepaymentPlan: RepaymentPlan,
    EssentialInformation: EssentialInformation,
};
/**
 * 案件信息业务组合
 */
export var tabs = [
    { name: 'essential-information', label: '基本信息' },
    { name: "public-debt-info", label: "共债信息" },
    // { name: "fix-info", label: "修复信息" },
    // { name: "annex-info", label: "附件信息" },
    { name: "cust-info", label: "客户信息" },
    { name: "case-info", label: "案件信息" },
];
